import { Layout } from 'lucide-react';

export const wixIntegration = {
    id: 'wix',
    name: 'Wix',
    icon: Layout,
    platformColor: '#000000',
    title: 'Wix Setup',
    why: 'Wix offers zero-code integration through its built-in custom script management, making it effortless to add AI-powered assistance to your website.',
    detailedGuide: '/docs/wix',
    steps: [
        {
            title: "Access ChytBot Dashboard",
            desc: "Log in to your ChytBot account. From the sidebar, navigate to \"Add to Website\" under the Integrations menu.",
            image: "/docs/screenshots/wix/integration.jpg",
            imgAlt: "ChytBot Add to Website menu"
        },
        {
            title: "Copy the Code Snippet",
            desc: "A unique code snippet will be generated for your chatbot. Click \"Copy Code\" to save it to your clipboard."
        },
        {
            title: "Open Wix Settings",
            desc: "Log in to your Wix dashboard. From the sidebar menu, click \"Settings\".",
            image: "/docs/screenshots/wix/wix_settings.png",
            imgAlt: "Wix Dashboard Settings"
        },
        {
            title: "Navigate to Custom Code",
            desc: "Scroll down to the \"Advanced\" section and click on \"Custom Code\".",
            image: "/docs/screenshots/wix/wis_custom_code.png",
            imgAlt: "Wix Custom Code section"
        },
        {
            title: "Add Code to Header",
            desc: "Under the \"Head\" section, click the \"+ Add Code\" button.",
            image: "/docs/screenshots/wix/add_code.png",
            imgAlt: "Add Code button"
        },
        {
            title: "Paste and Apply",
            desc: "Paste your ChytBot snippet into the text box. Name it \"ChytBot\" and click \"Apply\".",
            image: "/docs/screenshots/wix/pasye and apply.png",
            imgAlt: "Pasting code and applying"
        },
        {
            title: "Verify Integration",
            desc: "Your chatbot is now live! Visit your published Wix site to see it in action.",
            image: "/docs/screenshots/wix/chytbot.png",
            imgAlt: "Live ChytBot on Wix site"
        }
    ]
};
